module.exports = __webpack_public_path__ + "h5/img/noThing.4a4ac19f.png";